<template>
  <div class="country">
    <div
      v-if="country.iso"
      class="country-flag"
      :alt="country.iso"
      :title="country.name"
    >
      {{ flag }} {{ country.code }}
    </div>
    <div class="country-label">{{ country?.name || "" }}</div>
  </div>
</template>
<script>
import getUnicodeFlagIcon from "country-flag-icons/unicode";
export default {
  name: "CountryWithFlag",
  props: {
    country: {
      type: Object,
      required: true,
    },
  },
  computed: {
    flag() {
      return getUnicodeFlagIcon(this.country.iso.toUpperCase());
    },
  },
};
</script>
<style lang="scss" scoped>
.country {
  display: flex;
  &-flag {
    width: 80px;
  }
}
</style>
